import { render, staticRenderFns } from "./WeekdayWeekendReport.vue?vue&type=template&id=d567d360&"
import script from "./WeekdayWeekendReport.vue?vue&type=script&lang=ts&"
export * from "./WeekdayWeekendReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports